import { render, staticRenderFns } from "./OemMaterialAdd.vue?vue&type=template&id=71c171c8&scoped=true"
import script from "./OemMaterialAdd.vue?vue&type=script&lang=js"
export * from "./OemMaterialAdd.vue?vue&type=script&lang=js"
import style0 from "./OemMaterialAdd.vue?vue&type=style&index=0&id=71c171c8&prod&lang=scss"
import style1 from "./OemMaterialAdd.vue?vue&type=style&index=1&id=71c171c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c171c8",
  null
  
)

export default component.exports